module.exports = __webpack_public_path__ + "static/img/doc.b2b25e42.png";